module.exports = __webpack_public_path__ + "static/img/ARADIN3_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARADIN3_2.png
// module id = 3idA
// module chunks = 0